export const APP_SET_CUSTOM_DATA = "@APP/SetCustomData";
export const APP_REMOVE_EMBROIDERY_CUSTOM_DATA = "@APP/RemoveEmbroideryCustomData";
export const APP_INIT_CUSTOM_DATA = "@App/InitCustomData";
export const APP_RECEIVE_COMPONENT_FILTERS = "@App/ReceiveComponentFilters";
export const APP_SET_ACTIVE_COMPONENT_FILTER = "@App/SetActiveComponentFilter";
